module.exports = __webpack_public_path__ + "static/img/logo-green@3x.7a198a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-green@3x.png
// module id = GK5R
// module chunks = 1